import { render, staticRenderFns } from "./LocsPersonalMainContainer.vue?vue&type=template&id=544f0ee0"
import script from "./LocsPersonalMainContainer.vue?vue&type=script&lang=js"
export * from "./LocsPersonalMainContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports